import useSWR, { useSWRConfig } from "swr";

import baseClient from 'api/baseClient';
import adminHelper from 'helpers/adminHelper';

function useAdmin() {

    const { mutate } = useSWRConfig();

    const fetcher = async (endpoint) => {

        const adminResponse = await baseClient.get(endpoint);

        return adminResponse.data;
    }

    const { data, error, isLoading, mutate: mutateAdminRawData } = useSWR('club', fetcher, { refreshInterval: 60000 }); // 1min

    const adminRefetch = () => {
        mutate('club');
    }

    const mutateAdmin = (newData, revalidate = true) => {
        mutateAdminRawData(
            { ...data, ...newData },
            { revalidate: revalidate }
        );
    }

    return {
        adminData: new adminHelper(data),
        adminLoading: isLoading,
        adminError: error,
        adminRefetch,
        mutateAdmin,
    }
}

export default useAdmin;